const Chartist = require('chartist');
require('components/chartist/tooltip_plugin').register(Chartist);

module.exports = Chartist;



// WEBPACK FOOTER //
// ./javascripts/components/chartist-with-plugins.js